export default __webpack_public_path__ + "static/media/SerialTek_logo_simplified_PNG.c2cfbead.png";